import React from 'react';
import {Link} from 'react-router-dom';
import styles from './SiteFooter.module.css';
import LogoMark from './Logo';
import {CREATE_PAGE_ROUTE, HOW_TO_ROUTE, CONTACT_ROUTE, VIDEOS_ROUTE, HOME_ROUTE} from '../routes';

const LINKS = [
    {to: CREATE_PAGE_ROUTE, label: 'Create page'},
    {to: HOW_TO_ROUTE, label: 'How to'},
    {to: VIDEOS_ROUTE, label: 'Video guides'},
    {to: CONTACT_ROUTE, label: 'Contact'},
];

const SiteFooter = () => (
    <footer className={styles.footer}>
        <Link to={HOME_ROUTE} className={styles.brand} aria-label="Ovalview home">
            <LogoMark onDark/>
            <span className={styles.wordmark}>Ovalview</span>
        </Link>
        <nav aria-label="Footer" className={styles.nav}>
            {LINKS.map(({to, label}) => (
                <Link key={to} to={to} className={styles.navLink}>{label}</Link>
            ))}
        </nav>
        <span className={styles.copyright}>&copy; {new Date().getFullYear()} Ovalview</span>
    </footer>
);

export default SiteFooter;
